<template>
    <div id="hero">
        <div class="circle">
            <img src="@/assets/hero_circle.gif" alt="Circle with noise">
        </div>
        <div class="bg-pattern"></div>
        <div class="content-container">
            <div class="text">
                <h1 class="stagger">The Role of Design in Silicon Valley</h1>
                <h3 class="fadein">A collection of thoughts, blurbs, and perspectives from design-driven tech companies in the Bay Area—</h3>
            </div>
        </div>
        <div class="scroll-help">Scroll<span class="arrow"></span></div>
        <div class="character"></div>
    </div>
</template>

<script>
import LottieHero from "lottie-web";
import * as heroAnimationData from "@/assets/hero.json";

export default {
    name: "Hero",
    props: ["bus"],
    components: {
        LottieHero
    },
    data: function() {
        return {
            heroAnimation: null,
            circleAnimation: null
        };
    },
    mounted: function() {
        this.heroAnimation = LottieHero.loadAnimation({
            container: this.$el.querySelector(".character"),
            renderer: "svg",
            loop: true,
            autoplay: true,
            animationData: heroAnimationData.default
        });

        this.bus.$on("transition-exit", slideNum => {
            if (slideNum == 0) {
                this.exit();
            }
        });

        this.bus.$on("transition-enter", slideNum => {
            if (slideNum == 0) {
                this.enter();
            }
        });
    },
    methods: {
        enter: function() {
            this.heroAnimation.play();
        },
        exit: function() {
            setTimeout(() => {
                this.heroAnimation.stop();
            }, 1000);
        }
    }
};
</script>

<style lang="scss">
#hero {
    background: #faf8f0 url("../assets/wave_red.gif") left bottom no-repeat;
    width: 100%;
    height: 100vh;
    position: relative;
    overflow: hidden;

    @media ($mobile-screen) {
        background: #faf8f0;
        position: fixed;
    }

    .bg-pattern {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
    }

    .content-container {
        height: 100%;
        display: flex;
        align-items: center;
    }

    .text {
        width: 60%;
        transform: translate3d(0, -50px, 0);

        @media ($tablet-screen) {
            width: 80%;
            transform: translate3d(0, 0, 0);
        }

        @media ($small-laptop-screen) {
            width: 55%;
            transform: translate3d(0, 0, 0);
        }

        @media ($smallest-laptop-screen) {
            width: 73%;
            transform: translate3d(0, 0, 0);
        }

        @media ($mobile-screen) {
            width: 100%;
        }
    }

    h1 {
        font-size: 90px;

        @media ($laptop-screen) {
            font-size: 80px;
        }

        @media ($small-laptop-screen) {
            font-size: 70px;
        }

        @media ($mobile-screen) {
            font-size: 35px;
        }
    }

    h3 {
        @include mukta-light;
        font-size: 25px;
        max-width: 68%;
        margin-top: 45px;
        color: #595957;

        @media ($laptop-screen) {
            font-size: 20px;
        }

        @media ($mobile-screen) {
            font-size: 20px;
            max-width: 100%;
            margin-top: 20px;
        }
    }

    .scroll-help {
        @include playfair-black;
        font-size: 20px;
        margin-top: 50px;
        transform: rotate(90deg) translate3d(0, -15px, 0);
        transform-origin: top left;
        color: $color-black;
        position: absolute;
        left: 64px;
        bottom: 130px;

        @media ($mobile-screen) {
            font-size: 15px;
            left: 32px;
            bottom: 110px;
        }

        .arrow {
            display: inline-block;
            position: relative;
            padding-left: 20px;

            &:before {
                content: "";
                display: block;
                width: 25px;
                height: 1px;
                background-color: $color-black;
            }

            &:after {
                content: "";
                display: block;
                position: absolute;
                bottom: 0;
                right: 0;
                width: 10px;
                height: 1px;
                background-color: $color-black;
                transform: rotate(45deg);
                transform-origin: right;
            }
        }
    }

    .circle {
        position: absolute;
        right: 20px;
        bottom: 200px;
        width: 40%;

        @media ($laptop-screen) {
            mix-blend-mode: darken;
        }

        @media ($mobile-screen) {
            width: 100%;
            bottom: 0;
            right: 0;
        }

        img {
            max-width: 100%;
        }
    }

    .character {
        position: absolute;
        width: 55%;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: flex-end;

        @media ($mobile-screen) {
            width: 100%;
        }
    }
}
</style>